export default __webpack_public_path__ + "static/media/banner.8926aa92.png";